export enum EAutomationOutputTypes {
    EMAIL = 'email',
    WEBHOOK = 'webhook',
}